import { movies as moviesTypes } from '../constants/ActionTypes';
import { general as generalTypes } from '../constants/ActionTypes';
import axios from 'axios';

/**
 * Get list of movies
 * 
 * @returns 
 */
const getMovies = () => async (dispatch) => {
    dispatch({ type: generalTypes.LOADING, payload: true });
    getListMovies(dispatch)
};

/**
 * Get list of active movies
 * 
 * @returns 
 */
const getMoviesActive = () => async (dispatch) => {
    dispatch({ type: generalTypes.LOADING, payload: true });
    await axios.get(process.env.REACT_APP_URL + 'movies/active').then(resp => {
        dispatch({ type: moviesTypes.GET_MOVIES, payload: resp.data });
        dispatch({ type: generalTypes.LOADING, payload: false });
    }).catch(err => {
        dispatch({ type: generalTypes.LOADING, payload: false });
    });
};

/**
 * Add new movie
 * 
 * @param {*} form 
 * @returns 
 */
const setMovie = (form) => async (dispatch) => {
    dispatch({ type: generalTypes.LOADING, payload: true });
    await axios.post(process.env.REACT_APP_URL + 'movie', form).then(resp => {
        getListMovies(dispatch)
    }).catch(err => { dispatch({ type: generalTypes.LOADING, payload: false }); });
};

/**
 * Get movie by mid
 * 
 * @param {*} mid 
 */
const getMovie = (mid) => async (dispatch) => {
    dispatch({ type: generalTypes.LOADING, payload: true });
    await axios.get(process.env.REACT_APP_URL + 'movie/' + mid).then(resp => {
        dispatch({ type: moviesTypes.GET_MOVIE, payload: resp.data });
        dispatch({ type: generalTypes.LOADING, payload: false });
    }).catch(err => {
        dispatch({ type: generalTypes.LOADING, payload: false });
    });
}

/**
 * Update movie by mid
 * 
 * @param {*} form 
 * @returns 
 */
const setUpdate = (mid, form) => async (dispatch) => {
    dispatch({ type: generalTypes.LOADING, payload: true });
    await axios.put(process.env.REACT_APP_URL + 'movie/' + mid, { ...form, active: (form.active) ? 1 : 0 }).then(resp => {
        getListMovies(dispatch)
    }).catch(err => { dispatch({ type: generalTypes.LOADING, payload: false }); });
};

/**
 * Update cover by mid
 * 
 * @param {*} mid 
 * @param {*} cover 
 * @returns
 */
const setUpdateCover = (mid, file) => async (dispatch) => {
    return new Promise(async (resolve, error) => {
        dispatch({ type: generalTypes.LOADING, payload: true });
        const formData = new FormData();
        formData.append("file", file);
        formData.append("mid", mid);
        await axios.post(process.env.REACT_APP_URL + 'movie/cover', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: (progressEvent) => {
                const percent = Math.round((progressEvent.loaded * 100) / (progressEvent.total || 1));
            }
        }
        ).then(resp => {
            resolve(resp.data)
            dispatch({ type: generalTypes.LOADING, payload: false });
        }).catch(err => {
            error(err)
            dispatch({ type: generalTypes.LOADING, payload: false });
        });
    })
};

/**
 * Remove movie by mid
 * 
 * @param {*} mid 
 * @param {*} onClose 
 * @returns 
 */
const setRemove = (mid, onClose) => async (dispatch) => {
    onClose()
    dispatch({ type: generalTypes.LOADING, payload: true });
    await axios.delete(process.env.REACT_APP_URL + 'movie/' + mid).then(resp => {
        getListMovies(dispatch)
    }).catch(err => { dispatch({ type: generalTypes.LOADING, payload: false }); });
};

/**
 * Clear movie
 * @returns 
 */
const setClearMovie = () => async (dispatch) => {
    dispatch({ type: moviesTypes.GET_MOVIE, payload: null });
};

/**
 * Export const
 */
const exportConst = {
    getMoviesActive,
    getMovies,
    getMovie,
    setMovie,
    setRemove,
    setUpdate,
    setClearMovie,
    setUpdateCover
};

/**
 * Get list of movies
 * @param {*} dispatch 
 * @param {*} callBack 
 */
async function getListMovies(dispatch) {
    dispatch({ type: generalTypes.LOADING, payload: true });
    await axios.get(process.env.REACT_APP_URL + 'movies').then(resp => {
        dispatch({ type: moviesTypes.GET_MOVIES, payload: resp.data });
        dispatch({ type: generalTypes.LOADING, payload: false });
    }).catch(err => {
        dispatch({ type: generalTypes.LOADING, payload: false });
    });
}

export default exportConst;